export default __webpack_public_path__ + "static/media/Verified.0c0f17d3.svg";